import { Grid, Typography } from '@mui/material';
import { FormikHelpers } from 'formik';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from '../../../core/ui/layout/Layout';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import { parseValidationErrors } from '../../../core/utils/validation';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import { NewsletterEdit, Newsletter } from '../newsletter';
import EditNewsletterForm from '../components/EditNewsletterForm';
import ReturnButton from '../../../core/ui/utility/ReturnButton';
import Loader from '../../../core/ui/utility/Loader';
import { parseFormQuery } from '../../../core/utils/utility';

const EditNewsletterContainer = () => {
  const { id } = useParams();
  const { callApi, loading: submitting } = useSendApiData();
  const { fetchData, loading } = useFetchApiData();
  const [newsletter, setNewsletter] = useState<Newsletter | null>(null);

  const fetchNewsletter = () =>
    fetchData(`newsletters/${id}`, {
      onSuccess: (data: Newsletter) => {
        setNewsletter(data);
      },
    });

  useEffect(() => {
    fetchNewsletter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    values: NewsletterEdit,
    { setFieldError }: FormikHelpers<NewsletterEdit>
  ) => {
    let success = false;

    const formData: any = parseFormQuery(values);

    await callApi({
      endpoint: `auth-ea35a/newsletters/${id}?_method=PATCH`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        await fetchNewsletter();
        toastMessage('Newsletter Edited');
        success = true;
      },
    });

    return success;
  };

  return (
    <Layout renderLeftToolbar={() => <ReturnButton to="/newsletters" />}>
      <Loader loading={loading || !newsletter}>
        <Grid sx={{ p: 2 }}>
          <Grid container sx={{ mb: 1, px: 1 }}>
            <Typography variant="h5">Edit Newsletter</Typography>
          </Grid>
          <EditNewsletterForm
            newsletter={newsletter!}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        </Grid>
      </Loader>
    </Layout>
  );
};

export default EditNewsletterContainer;
